import { useMutation } from '@tanstack/react-query'

import { CreateReasonDto } from '@wwt/entities/api/search-response'

import { likeReasonQuery } from '../query/likeReasonQuery.ts'

export const useLikeReasonMutation = () => {
	return useMutation({
		mutationKey: ['like-reason'],
		mutationFn: async (requestBody: CreateReasonDto) => {
			return await likeReasonQuery(requestBody)
		}
	})
}
